module.exports = __webpack_public_path__ + "img/Bag 3.738a2b2c.svg";